// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M7 6V3A1 1 0 0 1 8 2H20A1 1 0 0 1 21 3V17A1 1 0 0 1 20 18H17V21C17 21.55 16.55 22 15.99 22H4.01A1 1 0 0 1 3 21V7C3 6.45 3.45 6 4.01 6ZM9 6H17V16H19V4H9Z"/>';

/** Copy (actions). */
const icon: IconData = {
  id: "copy",
  name: "Copy",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M7 6V3A1 1 0 0 1 8 2H20A1 1 0 0 1 21 3V17A1 1 0 0 1 20 18H17V21C17 21.55 16.55 22 15.99 22H4.01A1 1 0 0 1 3 21V7C3 6.45 3.45 6 4.01 6ZM5 8V20H15V8ZM9 6H17V16H19V4H9Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M20.39 2.08L20.71 2.29 20.92 2.61 21 3V17L20.92 17.39 20.71 17.71 20.39 17.92 20 18H17V21L16.92 21.39 16.7 21.71 16.38 21.92 15.99 22H4.01L3.62 21.93 3.3 21.71 3.08 21.39 3 21V7L3.08 6.61 3.29 6.29 3.62 6.08 4.01 6H7V3L7.08 2.61 7.29 2.29 7.61 2.08 8 2H20Z"/></g><path d="M7 6V3A1 1 0 0 1 8 2H20A1 1 0 0 1 21 3V17A1 1 0 0 1 20 18H17V21C17 21.55 16.55 22 15.99 22H4.01A1 1 0 0 1 3 21V7C3 6.45 3.45 6 4.01 6ZM5 8V20H15V8ZM9 6H17V16H19V4H9Z"/>',
    },
  },
  animation: () => import("../animations/copy.js"),
};

export default icon;
